exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "button.WatchlistButton__addToWishList___ayVSN{background:transparent;border:none;cursor:pointer;font-size:10px}button.WatchlistButton__addToWishList___ayVSN:hover{color:#fff}button.WatchlistButton__addToWishList___ayVSN em{font-style:normal}button.WatchlistButton__addToWishList___ayVSN span{background:#004f5c;color:#fff;border-radius:0;width:20px;height:20px;line-height:1.4;border:0;margin-left:2px;cursor:pointer;padding:1px 6px 3px}button.WatchlistButton__addToWishList___ayVSN span:hover{background:#fff;color:#004f5c}", ""]);

// exports
exports.locals = {
	"addToWishList": "WatchlistButton__addToWishList___ayVSN"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&importLoaders=1&localIdentName=[name]__[local]___[hash:base64:5]!./~/postcss-loader!./src/client/components/WatchlistButton/WatchlistButton.pcss
// module id = 940
// module chunks = 0